import * as moment from 'moment-timezone';
import { LOCAL_TZ } from '../../globals';
import { Metar } from '../models/metar.model';
import { convert, METERS, NAUTICAL_MILES, CELSIUS, FAHRENHEIT } from '../../util/units';
import { LatLon } from '../../util/geodesy/latlon';
import { getIntercardinalDirection } from '../../util/geodesy/helpers';
import { isNumeric } from '../../util/helpers';
import { LOCAL_TIME_FMT } from '../../util/datetime-utils';
var MetarComponent = /** @class */ (function () {
    function MetarComponent() {
        this.distance = null;
        this.direction = null;
        this.CELSIUS = CELSIUS;
        this.FAHRENHEIT = FAHRENHEIT;
        /**
         * Whether to display the METAR in translated mode
         */
        this.translated = true;
    }
    Object.defineProperty(MetarComponent.prototype, "raw", {
        get: function () {
            return !this.translated;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MetarComponent.prototype, "referencePoint", {
        /**
         * Reference lat/lon. If provided, the distance and bearing from the reference point will be shown in the header
         * (e.g., "25 nm NW").
         */
        set: function (point) {
            this._referencePoint = point;
            this.distance = null;
            this.direction = null;
            if (point) {
                var result = point.vincentyInverse(this.metar.location);
                if (result && !isNaN(result.distance)) {
                    this.distance = convert(result.distance, METERS, NAUTICAL_MILES);
                    this.direction = getIntercardinalDirection(result.initialBearing);
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MetarComponent.prototype, "issueTimeLocal", {
        get: function () {
            return moment(this.metar.observationTime).tz(LOCAL_TZ).format(LOCAL_TIME_FMT);
        },
        enumerable: true,
        configurable: true
    });
    MetarComponent.prototype.isNumeric = function (value) {
        return isNumeric(value);
    };
    return MetarComponent;
}());
export { MetarComponent };
